// useTelaGrande.js — "cabe a coluna da esquerda?", respondido em JavaScript.
//
// ================= POR QUE NÃO RESOLVE COM CSS (18/09/2026) =================
//
// O frete do livro é desenhado em dois lugares: embaixo da capa no computador,
// dentro do cartão de preço no celular. A primeira tentativa foi montar OS DOIS
// e esconder um com `hidden lg:block` / `lg:hidden`. Parece o caminho barato, e
// tem um defeito que só aparece quando se usa a tela:
//
//   esconder por CSS NÃO TIRA DO DOCUMENTO. Ficavam dois campos de CEP e QUATRO
//   botões de rádio com o mesmo `name` — e, para o navegador, rádios de mesmo
//   nome são UM grupo só. Escolher "Expressa" na versão visível era desfeito
//   pela versão escondida. Um teste de interação pegou isso; o print, não,
//   porque na foto tudo parecia certo.
//
// Com a pergunta em JavaScript, só UM dos dois é montado. Não há duplicata para
// divergir.
//
// O `matchMedia` é consultado JÁ NA PRIMEIRA RENDERIZAÇÃO (o `useState` recebe
// função), então não há o piscar de montar no lugar errado e corrigir depois. O
// ouvinte existe para quem gira o tablet ou redimensiona a janela.
import { useEffect, useState } from "react";

/** `lg` do Tailwind. Mudou lá, muda aqui — são a mesma decisão. */
const PADRAO = "(min-width: 1024px)";

const consultar = (consulta) =>
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(consulta).matches
    : false;

export default function useTelaGrande(consulta = PADRAO) {
  const [grande, setGrande] = useState(() => consultar(consulta));

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined;
    const mq = window.matchMedia(consulta);
    const aoMudar = (e) => setGrande(e.matches);
    setGrande(mq.matches);
    // `addEventListener` com recuo para o `addListener` antigo: Safari só
    // ganhou a forma moderna no 14, e um erro aqui derrubaria a página inteira.
    if (mq.addEventListener) mq.addEventListener("change", aoMudar);
    else mq.addListener(aoMudar);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", aoMudar);
      else mq.removeListener(aoMudar);
    };
  }, [consulta]);

  return grande;
}
